import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-white/5 mt-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid md:grid-cols-4 gap-8 text-sm">
      <div className="md:col-span-1">
        <div className="font-heading text-xl mb-2">Xook<span className="gold-text font-bold">Pub</span></div>
        <p className="text-white/60 max-w-xs">La puissance de l&apos;IA pour la création publicitaire indépendante : flyers, vidéos courtes et voix off cinéma.</p>
      </div>
      <div>
        <div className="label-mono mb-3">Studios</div>
        <ul className="space-y-2 text-white/70">
          <li>Flyer IA — Gemini Nano Banana</li>
          <li>Vidéo IA — Sora 2</li>
          <li>Voix Off — ElevenLabs</li>
        </ul>
      </div>
      <div>
        <div className="label-mono mb-3">Légal</div>
        <ul className="space-y-2 text-white/70">
          <li>
            <Link to="/legal/terms" data-testid="footer-terms" className="hover:text-gold transition">
              Conditions d&apos;utilisation
            </Link>
          </li>
          <li>
            <Link to="/legal/privacy" data-testid="footer-privacy" className="hover:text-gold transition">
              Confidentialité (RGPD)
            </Link>
          </li>
          <li>
            <Link to="/legal/mentions" data-testid="footer-mentions" className="hover:text-gold transition">
              Mentions légales
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <div className="label-mono mb-3">Propulsé par</div>
        <p className="text-white/60">Emergent · OpenAI · Google · ElevenLabs · Stripe</p>
        <p className="text-white/40 mt-3 text-xs">© {new Date().getFullYear()} XookPub. Indépendance professionnelle.</p>
      </div>
    </div>
  </footer>
);
